
<template>
  <div>
    <vx-card class="mb-2" v-if="draftRequest">
      <time-line :step="step" />
    </vx-card>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">راهنما</div>
        1- اطلاعات خواسته شده را تکمیل نمایید.
        <br />
        2- بارگزاری تصاویر هویتی (شامل کارت ملی، شناسنامه) برای تمامی متقاضیان
        اعم از حقیقی و حقوقی ضروری می‌باشد.
        <br />
        - برای اشخاص حقوقی تصویر کارت ملی و شناسنامه یکی از صاحبان امضا بارگزاری
        شود.
        <br />
        3- برای اشخاص حقوقی بارگزاری تصویر روزنامه رسمی (تعیین اعضای هیات مدیره)
        ضروری است.
        <br />
        4- ارائه کد رهگیری مالیاتی الزامی می باشد. جهت دریافت کد رهگیری می
        توانید از طریق لینک
        <a
          href="https://tax.gov.ir/action/do/registrationselector"
          target="_blunk"
          class="underline"
          >سازمان امور مالیاتی کشور</a
        >
        اقدام نمایید.
        <br />
        5- شماره شبا، کد پستی و کد رهگیری مالیاتی با اطلاعات هویتی متقاضی مطابقت
        داشته باشند.
        <br />
        6- پس از تکمیل فرم و دریافت پیامک تکمیل ثبت نام، منتظر بررسی درخواست
        توسط کارشناسان و فعالسازی حساب پذیرندگی خود باشید.
        <br />
        - شماره تماس پشتیبانی:
        <a href="tel:02126401398">
          <span class="link-txt">
            <i class="fa fa-phone"></i>
            <span class="link-ext"></span>
            <span class="txt">02126401398</span>
          </span>
        </a>
        <br />
        - شماره تماس واتساپ پشتیبانی:
        <a href="#" @click="openWhatsapp" class="whatsapp"> 09014114232 </a>
      </vs-collapse-item>
    </vs-collapse>
    <vx-card class="mb-2" :disabled="step > 1">
      <form>
        <div class="vx-row w-full mb-2">
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              label-placeholder="نام"
              v-validate="'required'"
              name="firstname"
              v-model="firstname"
              class="w-full mt-4"
            />
            <span class="text-danger text-sm" v-show="errors.has('firstname')"
              >نام راوارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              label-placeholder="نام خانوادگی"
              v-validate="'required'"
              name="lastname"
              v-model="lastname"
              class="w-full mt-4"
            />
            <span class="text-danger text-sm" v-show="errors.has('lastname')"
              >نام خانوادگی را وارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="کد ملی"
              v-validate="'digits:10|required'"
              name="nationalCode"
              v-model="nationalCode"
              class="w-full mt-4 ltr-input"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('nationalCode')"
              >کد ملی را صحیح وارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              label-placeholder="شماره شبا"
              v-validate="'digits:24|required'"
              v-model="defaultIban"
              name="defaultIban"
              class="w-full mt-4 ltr-input iban"
            />
            <span class="text-danger text-sm" v-show="errors.has('defaultIban')"
              >شبا وارد شده صحیح نمی باشد (24-{{ defaultIban.length }})</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="نام کسب و کار"
              v-validate="{
                regex: '^[0-9A-Za-z \u0600-\u06FF]+$',
                required: true,
              }"
              name="shopName"
              v-model="shopName"
              class="w-full mt-4"
            />
            <span class="text-danger text-sm" v-show="errors.has('shopName')"
              >نام کسب وکار را صحیح وارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="کد پستی"
              v-validate="'digits:10|required'"
              name="postalCode"
              v-model="postalCode"
              class="w-full mt-4 ltr-input"
            />
            <span class="text-danger text-sm" v-show="errors.has('postalCode')"
              >کد پستی را صحیح وارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="ایمیل"
              v-validate="'email|required'"
              name="email"
              v-model="email"
              class="w-full mt-4 ltr-input"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')"
              >ایمیل را صحیح وارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="کد رهگیری مالیاتی"
              v-validate="'digits:10|required'"
              name="taxCode"
              v-model="taxCode"
              class="w-full mt-4 ltr-input"
            />
            <span class="text-danger text-sm" v-show="errors.has('taxCode')"
              >کد مالیاتی را صحیح وارد کنید</span
            >
          </div>

          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <div class="vx-col w-full">
              <div class="" style="font-size: 0.8rem">استان*</div>
            </div>
            <div class="vx-col w-full">
              <v-select
                class="selectExample w-full"
                v-model="selectedProvince"
                @input="getCityList"
                :options="provinceList"
              ></v-select>
            </div>
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <div class="vx-col w-full">
              <div class="" style="font-size: 0.8rem">شهر*</div>
            </div>
            <div class="vx-col w-full">
              <v-select
                class="selectExample w-full"
                v-model="selectedCity"
                :options="cityList"
              ></v-select>
            </div>
          </div>

          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="تلفن (00000000-021)"
              v-validate="{ regex: '^0[0-9]{2}-[0-9]{4,8}$' }"
              name="tel"
              v-model="tel"
              class="w-full mt-4 ltr-input"
            />
            <span class="text-danger text-sm" v-show="errors.has('tel')"
              >تلفن را صحیح وارد کنید</span
            >
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
          >
            <vs-input
              inputmode="numeric"
              label-placeholder="وبسایت (وارد کردن وبسایت جهت درگاه پیامکی الزامی نیست)(http://www.my-site.com)"
              v-validate="{ regex: '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$' }"
              name="website"
              v-model="website"
              class="w-full mt-4 ltr-input"
            />
            <span class="text-danger text-sm" v-show="errors.has('website')"
              >سایت را صحیح وارد کنید</span
            >
          </div>

          <div class="vx-col mt-8 w-full">
            <vs-input
              inputmode="numeric"
              label-placeholder="آدرس"
              v-validate="{
                regex: '^[0-9A-Za-z. \u0600-\u06FF -]+$',
                required: true,
              }"
              name="address"
              v-model="address"
              class="w-full mt-4"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')"
              >آدرس را صحیح وارد کنید</span
            >
          </div>
        </div>

        <div class="vx-row w-full my-4">
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
          >
            <span>تصویر کارت ملی:</span>

            <picture-upload
              defaultText="تصویر کارت ملی"
              @change="uploadNationalCard"
              @remove="removeNationalCard"
              :img="attachments.NationalCard.bytes"
              :showRemoveBtn="
                attachments.NationalCard.attachment &&
                attachments.NationalCard.attachment.draftRequest &&
                true
              "
            />
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
          >
            <span>تصویر شناسنامه:</span>
            <picture-upload
              defaultText="تصویر شناسنامه"
              @change="uploadPersonalCertificate"
              @remove="removePersonalCertificate"
              :img="attachments.PersonalCertificate.bytes"
              :showRemoveBtn="
                attachments.PersonalCertificate.attachment &&
                attachments.PersonalCertificate.attachment.draftRequest &&
                true
              "
            />
          </div>
          <div
            class="vx-col mt-8 w-full xs:w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
          >
            <span>تصویر جواز کسب:</span>
            <picture-upload
              defaultText="تصویر جواز کسب"
              @change="uploadBusinessCertificate"
              @remove="removeBusinessCertificate"
              :img="attachments.BusinessCertificate.bytes"
              :showRemoveBtn="
                attachments.BusinessCertificate.attachment &&
                attachments.BusinessCertificate.attachment.draftRequest &&
                true
              "
            />
            <!-- <picture-input
            ref="pictureInput"
            @change="alert('ccc')"
            @prefill="alert('prefill')"
            @aspectratiochange="alert('aspectratiochange')"
            width="200"
            height="200"
            margin="10"
            accept="image/jpeg,image/png,image/jpg,application/pdf"
            size="10"
            :removable="true"
            :customStrings="{
              drag: 'تصویر جواز کسب',
              change: 'تغییر',
              remove: 'حذف ',
            }"
          >
          </picture-input> -->
          </div>
        </div>

        <!-- <div class="vx-row w-full my-4 mx-2">
          <div class="vx-col mt-8 px-0">
            <vs-checkbox v-model="isGateway"> </vs-checkbox>
          </div>
          <div class="vx-col mt-8 px-0">
            مایل به ثبت درگاه برای سایت وارد شده در بالا هستم. 
            <p style="font-size:0.8em">
              در صورتی که فقط قصد استفاده از خدمات پیامکی را دارید و مایل به استقرار درگاه روی وبسایت خود نمی باشید تیک بالا را نزنید.
              <br/>
              جهت اطلاعات بیشتر
            <a href="http://www.bistpay.com/terms/" target="_blunk"
              >سرویسهای ما</a
            >
را مطالعه کنید.
            </p>
          </div>
        </div> -->
        <div class="vx-row w-full my-4 mx-2">
          <div class="vx-col mt-8 px-0">
            <vs-checkbox v-model="accept"> </vs-checkbox>
          </div>
          <div class="vx-col mt-8 px-0">
            با
            <a href="http://www.bistpay.com/terms/" target="_blunk"
              >قوانین بیست پی</a
            >
            موافقم
          </div>
        </div>
        <div class="vx-row w-full my-4">
          <div class="vx-col mt-8 w-full">
            <vs-button
              v-if="step == 0"
              @click.prevent="save()"
              class="mx-3"
              color="success"
              icon-pack="feather"
              icon="icon-send"
              :disabled="!accept"
            >
              ثبت درخواست پذیرندگی
            </vs-button>
            <vs-button
              v-else
              @click.prevent="save()"
              class="mx-3"
              color="success"
              icon-pack="feather"
              icon="icon-edit"
              :disabled="!accept"
            >
              ویرایش درخواست پذیرندگی
            </vs-button>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>
<style lang="scss">
.vue-form-wizard .wizard-nav-pills {
  display: none;
}
.iban {
  .vs-con-input:before {
    content: "-IR";
    position: absolute;
    display: block;
    right: 7px;
    z-index: 9;
    padding-top: 4px;
  }
  input.vs-inputx {
    padding-right: 25px !important;
  }
}
.picture-inner {
  margin-top: 0.5em !important;
}
</style>
<script>
import Vue from "vue";
import Lightbox from "vue-easy-lightbox";
Vue.use(Lightbox);

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import PictureInput from "vue-picture-input";
import PictureUpload from "@/components/PictureUpload.vue";
import TimeLine from "./TimeLine.vue";
import { AttachmentType } from "@/enums.js";

export default {
  components: {
    FormWizard,
    TabContent,
    "v-select": vSelect,
    PictureInput,
    "picture-upload": PictureUpload,
    "time-line": TimeLine,
  },
  data() {
    return {
      draftRequest: {},
      AttachmentType,
      defaultIban: "",
      nationalCode: "",
      firstname: "",
      lastname: "",
      tel: "",
      website: "",
      shopName: "",
      email: "",
      postalCode: "",
      address: "",
      taxCode: "",
      attachments: {
        NationalCard: {},
        PersonalCertificate: {},
        BusinessCertificate: {},
      },
      visible: false,
      index: 0,
      selectedFiles: [],
      selectedImages: [],
      accept: false,
      provinceList: [],
      selectedProvince: {},
      cityList: [],
      selectedCity: {},
        promoterCode:null
    };
  },
  watch: {},
  computed: {
    step() {
      //not exist request
      if (!this.draftRequest || !this.draftRequest.step) return 0;
      //psp
      if (this.draftRequest.step == 1) {
        switch (this.draftRequest.state) {
          //inrequest
          case 0:
            return 0;
          //request
          case 1:
            return 1;
          //incomplate && complate
          case 2:
          case 3:
            return 2;
          default:
            return 3;
        }
      }
      // not psp
      else {
        //Approved
        if (this.draftRequest.state == 14) return 5;
        else return 4;
      }
      return 1;
    },
  },
  methods: {
    openWhatsapp(e) {
      //e.preventDefault();
      if (
        navigator.userAgent.toLowerCase().indexOf("android") > -1 ||
        navigator.userAgent.toLowerCase().indexOf("ios") > -1
      ) {
        window.location = "whatsapp://send?phone=989014114232";
      } else {
        //window.open('whatsapp://send?phone=989014114232', '_blank');
        window.open(
          "https://web.whatsapp.com/send?phone=989014114232",
          "_blank"
        );
      }
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          alert("form submitted!");
        } else {
          // form have errors
        }
      });
    },
    save() {
      let loading = this.$vs.loading();

      let payload = {
        nationalCode: this.nationalCode,
        firstname: this.firstname,
        lastname: this.lastname,
        tel: this.tel,
        iban: "IR" + this.defaultIban,
        shopName: this.shopName,
        postalCode: this.postalCode,
        address: this.address,
        email: this.email,
        taxCode: this.taxCode,
        promoterCode:this.promoterCode,
        website:this.website
      };

      if (this.selectedProvince && this.selectedProvince.value)
        payload.ProvinceCode = this.selectedProvince.value;

      if (this.selectedCity && this.selectedCity.value)
        payload.CityCode = this.selectedCity.value;

      this.$http
        .post("/api/services/app/Draft/CreateOrEdit_NewRequest", payload)
        .then((response) => {
          if (response.data.success) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده با موفقیت ذخیره شد",
            });
            this.getDraft();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http

      this.$vs.loading.close();
    },
    async getDraft(justLoadId = false) {
      let loading = this.$vs.loading();
      let steps = [1, 13, 5]; //["Psp","Shop","Terminal"];
      await this.$http
        .get(
          `/api/services/app/Draft/GetDrafts_CurrentUser?` +
            steps.map((n, index) => `steps[${index}]=${n}`).join("&")
        )
        .then(async (response) => {
          if (response.data.result.length) {
            this.draftRequest = response.data.result[0];
            this.accept = this.draftRequest.state;
            if (!justLoadId) {
              ///user have a request
              this.nationalCode = this.draftRequest.draftMerchant.nationalCode;
              this.firstname = this.draftRequest.draftMerchant.firstNameFa;
              this.lastname = this.draftRequest.draftMerchant.lastNameFa;
              this.tel = this.draftRequest.pspRequestShopAcceptors[0].shop.telephoneNumber;
              this.defaultIban = this.draftRequest.draftMerchant.merchantIbans[0].merchantIban.replace(
                "IR",
                ""
              );
              this.shopName = this.draftRequest.pspRequestShopAcceptors[0].shop.farsiName;
              this.postalCode = this.draftRequest.pspRequestShopAcceptors[0].shop.postalCode;
              this.address = this.draftRequest.pspRequestShopAcceptors[0].shop.address;
              this.email = this.draftRequest.pspRequestShopAcceptors[0].shop.emailAddress;
              this.taxCode = this.draftRequest.pspRequestShopAcceptors[0].shop.taxPayerCode;

              this.selectedProvince = this.provinceList.find(
                (x) =>
                  x.value ==
                  this.draftRequest.pspRequestShopAcceptors[0].shop.provinceCode
              );
              await this.getCityList(this.selectedProvince);
              this.selectedCity = this.cityList.find(
                (x) =>
                  x.value ==
                  this.draftRequest.pspRequestShopAcceptors[0].shop.cityCode
              );
            }
          } else {
            ///user does not have any request
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    async getAtachment(attachmentType) {
      if (!this.draftRequest.id) return;
      let loading = this.$vs.loading();
      let payload = {
        params: {
          DraftRequestId: this.draftRequest.id,
          AttachmentType: attachmentType.value,
        },
      };

      this.$http
        .get(`api/services/app/Draft/GetAttachments_CurrentUser`, payload)
        .then((response) => {
          this.attachments[attachmentType.name] = {};
          if (response.data.result[0]) {
            this.attachments[attachmentType.name] = response.data.result[0];
            this.attachments[attachmentType.name].bytes =
              "data:image/img;base64," +
              this.attachments[attachmentType.name].bytes;
          }
          // this.attachments = response.data.result.attachments.map(x => {
          //   return {
          //     url: "data:image/png;base64," + x.bytes,
          //     link: "data:image/png;base64," + x.bytes,
          //     size: x.bytes == null ? 0 : x.bytes.length,
          //     type: "image/img", // x.attachment.contentType,
          //     name: x.attachment.fileName,
          //     ext: "img"
          //   };
          // });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    getProvinceList() {
      let payload = {
        params: {
          MaxResultCount: 9999,
        },
      };
      this.$http
        .get("/api/services/app/Province/GetAll", payload)
        .then((response) => {
          this.provinceList = response.data.result.items.map((x) => {
            return {
              label: x.province.name,
              value: x.province.code,
            };
          });
        }) //end success
        .catch((error) => {}); //end http
    },
    async getCityList(item) {
      if (item == null) return;
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          ProvinceCodeFilter: item.value,
          MaxResultCount: 9999,
        },
      };
      await this.$http
        .get("/api/services/app/City/GetAll", payload)
        .then((response) => {
          this.selectedCity = null;
          this.cityList = response.data.result.items.map((x) => {
            return {
              label: x.city.name,
              value: x.city.code,
            };
          });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },

    uploadNationalCard(e) {
      this.upload(e, this.AttachmentType.NationalCard); //BusinessCertificate
    },
    uploadPersonalCertificate(e) {
      this.upload(e, this.AttachmentType.PersonalCertificate); //BusinessCertificate
    },
    uploadBusinessCertificate(e) {
      this.upload(e, this.AttachmentType.BusinessCertificate); //BusinessCertificate
    },
    upload(e, attachmentType) {
      let loading = this.$vs.loading();

      let formData = new FormData();
      formData.append("File", e.target.files[0]);
      formData.append("AttachmentType", attachmentType.value);
      if (this.draftRequest.id)
        formData.append("DraftRequestId", this.draftRequest.id);

      this.$http
        .post("/api/services/app/Draft/UploadAttachment_CurrentUser", formData)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `تصویر ${
                this.AttachmentType[attachmentType.name].title
              } با موفقیت ذخیره شد`,
            });
            if (!this.draftRequest.id) this.getDraft(true);
            this.getAtachment(attachmentType);
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },

    removeNationalCard() {
      this.removeFile(this.AttachmentType.NationalCard); //BusinessCertificate
    },
    removePersonalCertificate(e) {
      this.removeFile(this.AttachmentType.PersonalCertificate); //BusinessCertificate
    },
    removeBusinessCertificate() {
      this.removeFile(this.AttachmentType.BusinessCertificate); //BusinessCertificate
    },
    removeFile(attachmentType) {
      let loading = this.$vs.loading();
      let payload = {
        attachmentId: this.attachments[attachmentType.name].attachment.id,
        draftRequestId: this.draftRequest.id,
      };

      this.$http
        .post("/api/services/app/Draft/RemoveAttachment_CurrentUser", payload)
        .then((response) => {
          if (response.data.success) {
            this.getAtachment(attachmentType);
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `تصویر ${
                this.AttachmentType[attachmentType.name].title
              } حذف شد`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
  },
  async mounted() {
    this.getProvinceList();
    await this.getDraft();
    this.getAtachment(this.AttachmentType.NationalCard);
    this.getAtachment(this.AttachmentType.PersonalCertificate);
    this.getAtachment(this.AttachmentType.BusinessCertificate);
    this.promoterCode=localStorage.getItem('promoterCode');
  },
};
</script>